import React from 'react';

import { useFieldContext, FieldErrors } from '../';
import flaguk from '../../../assets/flags/uk.svg?url';
import flagus from '../../../assets/flags/us.svg?url';
import { Input, Label } from '../../Elements/';

type PhoneNumberFieldProps = {
	label: string;
	isUs?: boolean;
	icon?: React.ReactElement;
	phoneNumberPrefix?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const PhoneNumberFieldV2 = ({
	label,
	isUs,
	phoneNumberPrefix,
	icon,
	...inputProps
}: PhoneNumberFieldProps) => {
	const field = useFieldContext<string>();

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		let newVal = e.target.value;
		// allow only numeric input
		newVal = newVal.replace(/[^0-9.-]+/g, '');
		field.handleChange(newVal);
	};

	const flag = isUs ? flagus : flaguk;

	// hide the error messages until the field has been touched
	// only show errors after initial blur to prevent the error from displaying when first typing, meta.isBlurred is set to true after initial blur
	const hideErrors = !field.state.meta.isTouched || !field.state.meta.isBlurred;
	const hasErrors = field.state.meta.errors.length > 0 && !hideErrors;

	return (
		<>
			<div className='flex flex-row'>
				<Label
					htmlFor={field.name}
					label={label}
					className='mb-2'
					disabled={inputProps.disabled}
				/>
				{icon}
			</div>
			<div className='relative'>
				<img
					className='w-[24px] absolute left-4 top-[10px]'
					alt='input icon'
					src={flag}
					aria-hidden='true'
				/>
				<span className='absolute left-12 top-[11px] pr-2 border-primaryBorder border-r-[1px]'>
					{phoneNumberPrefix}
				</span>
				<Input
					value={field.state.value}
					onChange={onChange}
					onBlur={field.handleBlur}
					{...inputProps}
					name={field.name}
					id={field.name}
					className={isUs ? 'pl-20' : 'pl-24'}
					hasErrors={hasErrors}
				/>
			</div>
			<FieldErrors name={field.name} meta={field.state.meta} hideErrors={hideErrors} />
		</>
	);
};
